import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCaseContext } from '../context/CaseContext';

const MobileDiscrepancy = () => {
  const location = useLocation();
  const { fullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;

  const contradictions = location.state?.contradictions
    || (fir?.investigation?.contradictions?.length > 0 ? fir.investigation.contradictions : ['No contradictions found yet.']);
  const inconsistencies = location.state?.inconsistencies
    || (fir?.investigation?.inconsistencies?.length > 0 ? fir.investigation.inconsistencies : ['No inconsistencies found yet.']);

  return (
    <div>
      <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#094268', marginBottom: '10px' }}>Contradictions</h2>
      {contradictions.map((text, i) => (
        <div key={i} className="m-card" style={{ textAlign: 'justify' }}>{text}</div>
      ))}

      <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#094268', margin: '20px 0 10px' }}>Inconsistencies</h2>
      {inconsistencies.map((text, i) => (
        <div key={i} className="m-card" style={{ textAlign: 'justify' }}>{text}</div>
      ))}
    </div>
  );
};

export default MobileDiscrepancy;
